export const Handler = (() => {
  let i = 1;
  const listeners = {};

  return {
    addListener: (element, event, handler, capture) => {
      element.addEventListener(event, handler, capture);
      listeners[i] = { element, event, handler, capture };
      i += 1;
      return i;
    },
    removeListener: (id) => {
      if (id in listeners) {
        const h = listeners[id];
        h.element.removeEventListener(h.event, h.handler, h.capture);
      }
    },
  };
})();

export default {
  Handler,
};
